import { ENDPOINT_REQUEST as endpoints, history, SERVICES_REQUEST } from '../../configurations';
import { PATH } from '../../constants/paths';
import { actionType } from '../../constants/action-type';
import SafeMethod from 'crypto-js';
import { SESSION_STORAGE_KEY, STORAGE_KEY } from '../../constants/storage.key';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { isProduction, replaceEndSlash } from './env.func';

const USER_AGENT = navigator.userAgent.replace(/(\d+|\.|;|\/|:)/ig, '')
const SUPER_KEY = ['iTrader7.5', USER_AGENT].join('-')

export const removeFromStorage = (key) => {
  const storage = SESSION_STORAGE_KEY.includes(key) ? sessionStorage : localStorage
  storage.removeItem(key);
}

export const getSafeStorage = (key) => {
  const storage = SESSION_STORAGE_KEY.includes(key) ? sessionStorage : localStorage
  // TODO : Decrypt here
  let rawData = storage.getItem(key);
  if (rawData) {
    try {
      let dataDecrypted = SafeMethod.AES.decrypt(rawData, SUPER_KEY);
      return dataDecrypted.toString(SafeMethod.enc.Utf8);
    } catch (e) {
      return '';
    }
  } else {
    return '';
  }
}

export const saveSafeStorage = (key, data) => {
  const storage = SESSION_STORAGE_KEY.includes(key) ? sessionStorage : localStorage
  try {
    let dataEncrypted = SafeMethod.AES.encrypt(data, SUPER_KEY).toString();
    storage.setItem(key, dataEncrypted);
  }
  catch (e) {
    console.error(e);
  }
}

export const getSafe = (fn, defaultVal = '') => {
  try {
    let a = fn()
    return a == undefined ? defaultVal : a
  } catch (e) {
    return defaultVal
  }
}

export const isMobile = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

export const detectBrowsers = () => {
  // Opera 8.0+
  var isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';

  // Safari 3.0+ '[object HTMLElementConstructor]'
  var isSafari = /constructor/i.test(window.HTMLElement) ||
    (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] ||
      (typeof window['safari'] !== 'undefined' && window['safari'].pushNotification));

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !/OPR/.test(navigator.userAgent);

  // QQbrowser
  var isQQ = navigator.userAgent.toLowerCase().match(/tencenttraveler/) != null || navigator.userAgent.toLowerCase().match(/qqbrowse/) != null

  // Blink engine detection
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isOpera) {
    return 'opera';
  } else if (isFirefox) {
    return 'firefox';
  } else if (isSafari) {
    return 'safari';
  } else if (isEdge) {
    return 'edge';
  } else if (isQQ){
    return 'qq'
  }else if (isChrome) {
    return 'chrome';
  } else if (isBlink) {
    return 'blink';
  }else if (isIE) {
    return 'ie'
  }
}

export const getElementWidthHeightById = (elementId) => {
  let elm = document.getElementById(elementId);
  if (!elm) return;
  return {
    height: elm.offsetHeight,
    width: elm.offsetWidth
  }
}

export const geolocationCall = () => {
  let geolocation = {};
  // Will check if Needed
  // if (navigator.geolocation) {
  //     navigator.geolocation.watchPosition(function(position) {
  //         geolocation =  {
  //             lng: position.coords.longitude,
  //             lat: position.coords.latitude
  //         }
  //         return geolocation;
  //     });
  // }
  return geolocation;
}

String.prototype.format = function () {
  var args = Array.prototype.slice.call(arguments, 0);
  return this.replace(/\{(\d+)\}/g, function (match, index) {
    return args[index];
  });
}
String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
}

export const combineServicesUrl = (baseUrl, port) => {
  return `${baseUrl}:${port}/`;
}

export const getCaptchaImg = () => {
  let url = replaceEndSlash(appConfigConstants.itradeAPI)
  url = `${url}${SERVICES_REQUEST.COMMON_V1}/${endpoints.iAUTH.IMAGE_CAPTCHA}?${new Date().getTime()}`
  return url
}

export const getDeviceInfo = () => {
  return {
    device: navigator.userAgent,
    deviceID: navigator.platform,
  }
}

export function getUserIp() {
  return new Promise(resolve => {
    const api = 'https://api.ipify.org/?format=jsonp&callback=getUserIp'

    const script = document.createElement('script')
    script.src = api
    document.body.appendChild(script)

    window.getUserIp = ({ ip }) => {
      script.remove()
      resolve(ip)
      delete window.getUserIp
    }

    setTimeout(() => {
      script.remove()
      resolve('127.0.0.1')
    }, 6000)
  })
}

function getWebRtcIp() {
  return new Promise(resolve => {
    const RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    if (RTCPeerConnection) {
      const connection = new RTCPeerConnection()
      connection.onicecandidate = ice => {
        if (ice && ice.candidate) {
          if (ice.candidate.foundation) {
            resolve(ice.candidate.foundation.toString())
          } else if (typeof ice.candidate.candidate === 'string') {
            const candidates = ice.candidate.candidate.split(' ')
            const foundation = candidates[0]?.split(':')?.[1]
            if (foundation && !(foundation === '0' || foundation === '1')) resolve(foundation)
            else resolve(null)
          }
        }
      }
      connection.createDataChannel('wen')
      connection.createOffer(res => connection.setLocalDescription(res), () => {})

      setTimeout(() => {
        resolve(null)
      }, 2000)

    } else {
      resolve(null)
    }
  })
} 

let fingerprintjs
export const getFingerprint = () => {
  return new Promise(async resolve => {
    let deviceId = getSafeStorage(STORAGE_KEY.DEVICE_ID)
    if (!deviceId) {
      if (!fingerprintjs) {
        fingerprintjs = (await import('@fingerprintjs/fingerprintjs')).default
      }
      const excludes = [
        'webdriver', 
        'language', 
        'sessionStorage',
        'localStorage',
        'indexedDb',
        'addBehavior',
        'openDatabase',
        'cpuClass',
        'doNotTrack',
        'plugins',
        'hasLiedOs',
        'hasLiedBrowser',
        'hasLiedLanguages',
        'hasLiedResolution',
        'adBlock',
        'fontsFlash', 
        'enumerateDevices',
      ].reduce((prev, next) => (prev[next] = true, prev), {})
      let deviceInfoId = await getWebRtcIp()

      if (!deviceInfoId) {
        deviceInfoId = await fingerprintjs.getPromise({ excludes })
        deviceInfoId = deviceInfoId.map(v => v.value).join(' ')
      }

      deviceId = fingerprintjs.x64hash128(deviceInfoId).split('').slice(0, 24).reduce((prev, next, index) => {
        if (index && index % 6 === 0) prev += `-${next}`
        else prev += next
        return prev
      })
      saveSafeStorage(STORAGE_KEY.DEVICE_ID, deviceId)
    }
    resolve(deviceId)
  })
}

export const checkFullLayoutRedirect = () => {
  const { location } = history;
  if (location) {
    const currentPath = location.pathname;
    if (currentPath === PATH.LOGIN || currentPath === PATH.REGISTER || currentPath === PATH.FORGOT_PW || currentPath === PATH.CHECK_AUTH) {
      return;
    } else { 
      if(iTradeEnv.thirdPartyLink) {
        window.location.href = iTradeEnv.thirdPartyLink
      } else {
        history.push(PATH.LOGIN);
      }
    }
  }
}

export const getClassnameColorByValue = (value) => {
  if (parseFloat(value) === 0) return '';
  return parseFloat(value) > 0 ? 'rise-color' : 'fall-color';
}

export const getCompanyAndMarketInformation = (appEvn, theme) => {
  const regex = /dark|light/
  const fullLogoImgName = appEvn?.layouts?.fullLayout?.logoImgName
  const mainLogoImgName = appEvn?.layouts?.mainLayout?.logoImgName

  let logoURL
  let mainLogoURL

  if (fullLogoImgName) {
    logoURL = require(`../../companys/${iTradeEnv.company}/assets/images/logo/${fullLogoImgName.replace(regex, theme)}`)
  } else {
    logoURL = require('../../companys/ttl/assets/images/logo/logo.png')
  }

  if (mainLogoImgName) {
    mainLogoURL = require(`../../companys/${iTradeEnv.company}/assets/images/logo/${mainLogoImgName.replace(regex, theme)}`)
  } else {
    mainLogoURL = require('../../companys/ttl/assets/images/logo/logo.png')
  }

  return {
    logoURL: logoURL.default,
    mainLogoURL: mainLogoURL.default,
    className: `customize-${appEvn.company}`,
    ...appEvn
  }
}

export const getConfigComponent = (bool, component, defaultComponent = null) => bool && component || (() => defaultComponent)

export const getInitState = (data) => {
  var company = iTradeEnv.company
  return function(name, props, defaultVal) {
    const result = data[name.replace('TTL', company.toLocaleUpperCase())]
    if (typeof result === 'function') return result(props)
    return result ?? defaultVal
  }
}

export const getCompanyRender = (components) => {
  var company = iTradeEnv.company
  return function({ name, args = [] }, defaultVal) {
    const func = components[name.replace('TTL', company.toLocaleUpperCase())]
    return typeof func === 'function' && func.bind(this, ...args) || defaultVal || (() => null)
  }
}

export const onChangeTab = (action, ref) => {
  switch (action) {
    case actionType.NEXT:
      ref.focus();
      break;
    case actionType.PREVIOUS:
      ref.focus();
      break;
    default: break;
  }
}

export const setCookie = (name, value, options = {}) => {
  options = {
    path: '/',
    domain: 'http://tts.tx-tech.com',
    // add other defaults here if necessary
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
}

export const readCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const createCookie = (name, value, days) => {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

export const eraseCookie = (name) => {
  createCookie(name, "", -1);
}

export function logMessage(message) {
  if (window.isLoggingEnabled) {
    const now = new Date();
    console.log(`${now.toLocaleTimeString()}.${now.getMilliseconds()}> ${message}`);
  }
}

export function getErrorMessage(error) {
  if (error === undefined) {
    return '';
  } else if (typeof error === 'string') {
    return error;
  }

  return error.message;
}

export const checkIsTabs = () => {
  if (!iTradeEnv.checkTabs) return Promise.resolve(true)
  return new Promise(resolve => {
    const time = Date.now().toString()
    let isOpen = false
  
    const ref = setTimeout(() => {
      if (!isOpen) {
        isOpen = true
        resolve(true)
      }
    }, 500)
    
    const onStorageChange = ({ key, newValue }) => {
      const timeDecrypted = SafeMethod.AES.decrypt(newValue, SUPER_KEY).toString(SafeMethod.enc.Utf8)
      // !(isProduction() && window.config?.webPath && !location.pathname.includes(window.config.webPath))
      if (key === STORAGE_KEY.TIME && !isOpen && timeDecrypted !== time) {
        ref && clearTimeout(ref)
        window.removeEventListener('storage', onStorageChange)
        resolve(false)
      } else if (key === STORAGE_KEY.TIME && isOpen) {
        saveSafeStorage(STORAGE_KEY.TIME, time)
        resolve(true)
      }
    }
  
    window.addEventListener('storage', onStorageChange)
    saveSafeStorage(STORAGE_KEY.TIME, time)
  })
}

export const setHtmlLanguage = (lang) => {
  document.documentElement.lang = lang.replace('_', '-')
}

export const hasValType = (obj) => {
  return Object.prototype.toString.call(obj).slice(8, -1)
}

export const deepClone = (target, hash = new WeakMap()) => {
  let type = hasValType(target)
  let result = null
  if (type == 'Object') {
    result = {}
  } else if (type == 'Array') {
    result = []
  } else {
    return target
  }
  if (hash.has(target)) {
    return hash.get(target)
  }
  hash.set(target, result) 
  for (let i in target) {
    if (
      hasValType(target[i]) == 'Object' ||
      hasValType(target[i]) == 'Array'
    ) {
      result[i] = deepClone(target[i], hash) 
    } else {
      result[i] = target[i]
    }
  }
  return result
}